import React from 'react'
import styled from 'styled-components'
import palette from 'core-system/Themes/palette'
import { DashboardPeriod } from '../dashboardTypes'

const PERIOD_OPTIONS: { value: DashboardPeriod; label: string }[] = [
  { value: 7, label: '7d' },
  { value: 30, label: '30d' },
  { value: 90, label: '90d' },
  { value: 'all', label: 'All' },
]

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem;
  border-radius: 999px;
  background-color: ${palette.grey.grey200};
`

const Option = styled.button<{ $active: boolean }>`
  appearance: none;
  border: none;
  cursor: pointer;
  padding: 0.375rem 0.875rem;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.25;
  color: ${(props) =>
    props.$active ? palette.text.primary : palette.text.secondary};
  background-color: ${(props) =>
    props.$active ? palette.white : 'transparent'};
  box-shadow: ${(props) =>
    props.$active ? '0 1px 2px rgba(13, 12, 12, 0.08)' : 'none'};
  transition:
    background-color 0.15s ease,
    box-shadow 0.15s ease,
    color 0.15s ease;

  &:hover {
    color: ${palette.text.primary};
  }

  &:focus-visible {
    outline: 2px solid ${palette.primary.pink500};
    outline-offset: 2px;
  }
`

interface PeriodSelectorProps {
  value: DashboardPeriod
  onChange: (period: DashboardPeriod) => void
}

const PeriodSelector = ({ value, onChange }: PeriodSelectorProps) => {
  return (
    <Container
      role='group'
      aria-label='Time period'
      data-cy='programs-period-selector'
    >
      {PERIOD_OPTIONS.map((option) => (
        <Option
          key={option.value}
          type='button'
          $active={value === option.value}
          aria-pressed={value === option.value}
          data-cy={`programs-period-${option.label}`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Option>
      ))}
    </Container>
  )
}

export default React.memo(PeriodSelector)
